import { usePrefetchQuery } from 'queries/helpers';
import { ACTIVITIES } from 'queries/query-keys';
import { useQuery } from '@tanstack/react-query';
import CustomObjectsService from 'services/CustomObjectsService';
import ActivityService from 'services/ActivityService';
import { FORCE_ALL_RECORDS_SIZE } from 'services/helpers';

export const useActivitiesQuery = (opts) => {
  return useQuery({
    queryKey: ACTIVITIES.ALL,
    queryFn: () => ActivityService.getActivities(),
    ...opts,
  });
};

/**
 * Access the activity default relationship data
 */
export const useDefaultActivityRelationshipsQuery = (opts) => {
  return useQuery({
    queryKey: ACTIVITIES.DEFAULT_RELATIONSHIPS,
    queryFn: async () => {
      const data = await CustomObjectsService.getCustomObjectList({
        size: FORCE_ALL_RECORDS_SIZE,
        defaultOnActivities: true,
        customOnly: false,
      });
      return data.results;
    },
    refetchOnWindowFocus: opts?.refetchOnWindowFocus,
  });
};

export const useCamelCaseActivityQuery = (
  activityObjectId,
  {
    enabled,
    initialData,
    retry,
    refetchInterval,
    refetchIntervalInBackground,
    refetchOnWindowFocus = false,
  } = {},
  apiOptions
) => {
  return useQuery({
    queryKey: ACTIVITIES.ACTIVITY_CAMEL(activityObjectId),
    queryFn: async () => {
      return ActivityService.v2GetActivity({ activityObjectId }, apiOptions);
    },
    enabled,
    initialData,
    retry,
    refetchInterval,
    refetchIntervalInBackground,
    refetchOnWindowFocus,
    throwOnError: false,
  });
};

/**
 * Call me near the top of a tree that may need the default activity activity relat
 */
export const useDefaultActivityRelationshipsPrefetch = () => {
  usePrefetchQuery((queryClient) =>
    queryClient.prefetchQuery({
      queryKey: ACTIVITIES.DEFAULT_RELATIONSHIPS,
      queryFn: async () => {
        const data = await CustomObjectsService.getCustomObjectList({
          size: FORCE_ALL_RECORDS_SIZE,
          defaultOnActivities: true,
          customOnly: false,
        });
        return data.results;
      },
    })
  );
};
